var React = require('react');

function IconLinkedinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15ZM9.526 9.947a1.474 1.474 0 1 0 0-2.947 1.474 1.474 0 0 0 0 2.947Zm11.968 2.769a4.421 4.421 0 0 0-7.547 3.126V21h2.948v-5.158a1.474 1.474 0 0 1 2.947 0V21h2.947v-5.158a4.421 4.421 0 0 0-1.295-3.126ZM11 12.158V21H8.053v-8.842H11Z","fill":"#fff"}));
}

IconLinkedinInline.defaultProps = {"width":"30","height":"30","fill":"none"};

module.exports = IconLinkedinInline;

IconLinkedinInline.default = IconLinkedinInline;
